import { render, staticRenderFns } from "./RealizedGainsComponent.vue?vue&type=template&id=6621c5c0&scoped=true&"
import script from "./RealizedGainsComponent.vue?vue&type=script&lang=ts&"
export * from "./RealizedGainsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./RealizedGainsComponent.vue?vue&type=style&index=0&id=6621c5c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6621c5c0",
  null
  
)

export default component.exports